import fr from 'facet-rest';
import BaseOverride from './BaseOverride';

const PersonalInformationOverride = fr.metaOverride({ base: BaseOverride });

export default PersonalInformationOverride;
